import { PARTICIPANTS_ROUTER_ROOT, PARTICIPANTS_ROUTER_NEW, PARTICIPANTS_ROUTER_EDIT } from './constants';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import ParticipantsList from './ParticipantsList';
import ParticipantsNew from './ParticipantsNew';
import ParticipantsEdit from './ParticipantsEdit';

const settings = {
  router: [
    {
      path: PARTICIPANTS_ROUTER_ROOT,
      component: ParticipantsList
    },
    // new
    {
      path: PARTICIPANTS_ROUTER_NEW,
      component: connect(undefined, dispatch => ({
        goIndex: () => dispatch(push(PARTICIPANTS_ROUTER_ROOT))
      }))(ParticipantsNew)
    },
    // edit
    {
      path: PARTICIPANTS_ROUTER_EDIT,
      component: connect(undefined, dispatch => ({
        goIndex: () => dispatch(push(PARTICIPANTS_ROUTER_ROOT))
      }))(ParticipantsEdit)
    }
  ]
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/Participants/index.js